import { render, staticRenderFns } from "./UserWords.vue?vue&type=template&id=5a92fc5b&scoped=true&"
import script from "./UserWords.vue?vue&type=script&lang=js&"
export * from "./UserWords.vue?vue&type=script&lang=js&"
import style0 from "./UserWords.vue?vue&type=style&index=0&id=5a92fc5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a92fc5b",
  null
  
)

export default component.exports